export class HalfFloatUtils {
    static __init__() {
        for (var i = 0; i < 256; ++i) {
            var e = i - 127;
            if (e < -27) {
                _baseTable[i | 0x000] = 0x0000;
                _baseTable[i | 0x100] = 0x8000;
                _shiftTable[i | 0x000] = 24;
                _shiftTable[i | 0x100] = 24;
            }
            else if (e < -14) {
                _baseTable[i | 0x000] = 0x0400 >> (-e - 14);
                _baseTable[i | 0x100] = (0x0400 >> (-e - 14)) | 0x8000;
                _shiftTable[i | 0x000] = -e - 1;
                _shiftTable[i | 0x100] = -e - 1;
            }
            else if (e <= 15) {
                _baseTable[i | 0x000] = (e + 15) << 10;
                _baseTable[i | 0x100] = ((e + 15) << 10) | 0x8000;
                _shiftTable[i | 0x000] = 13;
                _shiftTable[i | 0x100] = 13;
            }
            else if (e < 128) {
                _baseTable[i | 0x000] = 0x7c00;
                _baseTable[i | 0x100] = 0xfc00;
                _shiftTable[i | 0x000] = 24;
                _shiftTable[i | 0x100] = 24;
            }
            else {
                _baseTable[i | 0x000] = 0x7c00;
                _baseTable[i | 0x100] = 0xfc00;
                _shiftTable[i | 0x000] = 13;
                _shiftTable[i | 0x100] = 13;
            }
        }
        _mantissaTable[0] = 0;
        for (i = 1; i < 1024; ++i) {
            var m = i << 13;
            e = 0;
            while ((m & 0x00800000) === 0) {
                e -= 0x00800000;
                m <<= 1;
            }
            m &= ~0x00800000;
            e += 0x38800000;
            _mantissaTable[i] = m | e;
        }
        for (i = 1024; i < 2048; ++i) {
            _mantissaTable[i] = 0x38000000 + ((i - 1024) << 13);
        }
        _exponentTable[0] = 0;
        for (i = 1; i < 31; ++i) {
            _exponentTable[i] = i << 23;
        }
        _exponentTable[31] = 0x47800000;
        _exponentTable[32] = 0x80000000;
        for (i = 33; i < 63; ++i) {
            _exponentTable[i] = 0x80000000 + ((i - 32) << 23);
        }
        _exponentTable[63] = 0xc7800000;
        _offsetTable[0] = 0;
        for (i = 1; i < 64; ++i) {
            if (i === 32) {
                _offsetTable[i] = 0;
            }
            else {
                _offsetTable[i] = 1024;
            }
        }
    }
    static roundToFloat16Bits(num) {
        _floatView[0] = num;
        var f = _uint32View[0];
        var e = (f >> 23) & 0x1ff;
        return _baseTable[e] + ((f & 0x007fffff) >> _shiftTable[e]);
    }
    static convertToNumber(float16bits) {
        var m = float16bits >> 10;
        _uint32View[0] = _mantissaTable[_offsetTable[m] + (float16bits & 0x3ff)] + _exponentTable[m];
        return _floatView[0];
    }
}
const _buffer = new ArrayBuffer(4);
const _floatView = new Float32Array(_buffer);
const _uint32View = new Uint32Array(_buffer);
const _baseTable = new Uint32Array(512);
const _shiftTable = new Uint32Array(512);
const _mantissaTable = new Uint32Array(2048);
const _exponentTable = new Uint32Array(64);
const _offsetTable = new Uint32Array(64);
